export default [
    {
        title: "Mount Fuji",
        location: "Japan",
        googleMapsUrl: "https://goo.gl/maps/1DGM5WrWnATgkSNB8",
        startDate: "12 Jan, 2021",
        endDate: "24 Jan, 2021",
        description: "Mount Fuji is the tallest mountain in Japan, standing at 3,776 meters (12,380 feet). Mount Fuji is the single most popular tourist site in Japan, for both Japanese and foreign tourists. Mount Fuji is still an active volcano today.",
        imageUrl: "https://source.unsplash.com/WLxQvbMyfas",
        badge:'dangerous'
    },
    {
        title: "Angkor Wat",
        location: "Cambodia",
        googleMapsUrl: 'https://www.google.com/maps/d/u/0/viewer?hl=en&mid=1826TEZz4mbjpCzArUnUTQtPc0x0&ll=13.412469000000023%2C103.866986&z=17',
        startDate: "20 Aug, 2022",
        endDate: "24 Aug, 2022",
        description: "Angkor Wat is an enormous Buddhist temple complex located in northern Cambodia. It was originally built in the first half of the 12th century as a Hindu temple. Spread across more than 400 acres, Angkor Wat is said to be the largest religious monument in the world.",
        imageUrl: "https://cdn.britannica.com/49/94449-050-ECB0E7C2/Angkor-Wat-temple-complex-Camb.jpg",
        badge:'not'
    },
    {
        title: "The Parthenon",
        location: "Greece",
        googleMapsUrl: "https://www.google.com/maps/d/u/0/viewer?hl=en&mid=1826TEZz4mbjpCzArUnUTQtPc0x0&ll=37.97152850000003%2C23.726716600000017&z=17",
        startDate: "12 Jan, 2023",
        endDate: "14 Jan, 2023",
        description: "The Parthenon is a resplendent marble temple built between 447 and 432 B.C. during the height of the ancient Greek Empire. Dedicated to the Greek goddess Athena, the Parthenon sits high atop a compound of temples known as the Acropolis of Athens.",
        imageUrl: "https://upload.wikimedia.org/wikipedia/commons/thumb/d/da/The_Parthenon_in_Athens.jpg/450px-The_Parthenon_in_Athens.jpg",
        badge:'not dangerous'
    },
    {
        title: "The Louvre",
        location: "France",
        googleMapsUrl: "https://www.google.com/maps/d/u/0/viewer?hl=en&mid=1826TEZz4mbjpCzArUnUTQtPc0x0&ll=48.860611100000014%2C2.33764400000001&z=17",
        startDate: "12 Dec, 2022",
        endDate: "20 Dec, 2022",
        description: "The Louvre is the world's largest museum and houses one of the most impressive art collections in history. The magnificent, baroque-style palace and museum — LeMusée du Louvre in French — sits along the banks of the Seine River in Paris. It is one of the city's biggest tourist attractions.",
        imageUrl: "https://media.architecturaldigest.com/photos/5900cc370638dd3b70018b33/16:9/w_2560%2Cc_limit/Secrets%2520of%2520Louvre%25201.jpg",
        badge:'not dangerous'
    },
    {
        title: "Taj Mahal",
        location: "India",
        googleMapsUrl: "https://www.google.com/maps/d/u/0/viewer?hl=en&mid=1826TEZz4mbjpCzArUnUTQtPc0x0&ll=27.175144800000034%2C78.04214220000001&z=17",
        startDate: "12 Oct, 2021",
        endDate: "24 Oct, 2021",
        description: "An immense mausoleum of white marble, built in Agra between 1631 and 1648 by order of the Mughal emperor Shah Jahan in memory of his favourite wife, the Taj Mahal is the jewel of Muslim art in India and one of the universally admired masterpieces of the world's heritage.",
        imageUrl: "https://www.wonders-of-the-world.net/Taj-Mahal/images/Decouvrir/Mausolee.jpg"
    },
    {
        title: "The Colosseum",
        location: "Italy",
        googleMapsUrl: "https://www.google.com/maps/d/u/0/viewer?hl=en&mid=1826TEZz4mbjpCzArUnUTQtPc0x0&ll=41.89021019999998%2C12.492230899999983&z=17",
        startDate: "21 Feb, 2023",
        endDate: "24 Feb, 2023",
        description: "The Colosseum is an amphitheatre built in Rome under the Flavian emperors of the Roman Empire. It is also called the Flavian Amphitheatre. It is an elliptical structure made of stone, concrete, and tuff, and it stands four stories tall at its highest point.",
        imageUrl: "https://www.thecolosseum.org/wp-content/uploads/2017/09/Colosseum-optimized.jpg"
    },
    {
        title: "Machu Picchu",
        location: "Peru",
        googleMapsUrl: "https://www.google.com/maps/d/u/0/viewer?hl=en&mid=1826TEZz4mbjpCzArUnUTQtPc0x0&ll=-13.162824499999969%2C-72.5452449&z=17",
        startDate: "12 Jan, 2022",
        endDate: "20 Jan, 2022",
        description: "Machu Picchu , Ancient fortress city of the Incas in the Andes Mountains, south-central Peru. Perched near Cuzco in a narrow saddle between two sharp peaks, at an elevation of 7,710 ft (2,350 m), it escaped detection by the Spaniards, and its existence was made known only in 1911 by U.S. explorer Hiram Bingham.",
        imageUrl: "https://www.collinsdictionary.com/images/full/machupicchu_147330278_1000.jpg"
    },
    {
        title: "Great Wall Of China",
        location: "China",
        googleMapsUrl: "https://www.google.com/maps/d/u/0/viewer?hl=en&mid=1826TEZz4mbjpCzArUnUTQtPc0x0&ll=40.431907700000004%2C116.57037490000005&z=17",
        startDate: "12 Jan, 2024",
        endDate: "16 Jan, 2024",
        description: "The Great Wall of China is a series of fortifications that were built across the historical northern borders of ancient Chinese states. It is the longest structure humans have ever built. It is about 21,196 kilometers long, 9.1 metres (30 feet) wide and 15 metres high.",
        imageUrl: "https://cdn.britannica.com/54/122154-131-52D686FF/Great-Wall-of-China.jpg"
    },

    {
        title: "Giza Pyramid Complex",
        location: "Egypt",
        googleMapsUrl: "https://www.google.com/maps/d/u/0/viewer?hl=en&mid=1826TEZz4mbjpCzArUnUTQtPc0x0&ll=29.981892313353736%2C31.139077842814594&z=14",
        startDate: "12 July, 2022",
        endDate: "24 July, 2021",
        description: "This pyramid and its surrounding complex are generally considered to be the world's oldest monumental structures constructed of dressed masonry. The most famous Egyptian pyramids are those found at Giza, on the outskirts of Cairo. Several of the Giza pyramids are counted among the largest structures ever built.",
        imageUrl: "https://upload.wikimedia.org/wikipedia/commons/thumb/9/96/Pyramids_of_the_Giza_Necropolis.jpg/1200px-Pyramids_of_the_Giza_Necropolis.jpg"
    },
    {
        title: "Snake Island",
        location: "Brazil",
        googleMapsUrl: "https://www.google.com/maps/d/u/0/viewer?hl=en&mid=1826TEZz4mbjpCzArUnUTQtPc0x0&ll=-24.487922056011087%2C-46.6741553504235&z=14",
        startDate: "2 Jan, 2023",
        endDate: "4 Jan, 2023",
        description: "Ilha da Queimada Grande, also known as Snake Island, is an island off the coast of Brazil in the Atlantic Ocean. It is administered as part of the municipality of Itanhaém in the State of São Paulo. The island is small in size, only 43 hectares (106 acres), and has a temperate climate. You will just die.",
        imageUrl: "https://www.worldatlas.com/r/w768/upload/5a/13/1b/shutterstock-1304906005.jpg",
        badge : 'dangerous'
    },
    {
        title: "Lake Natron",
        location: "Tanzania",
        googleMapsUrl: "https://www.google.com/maps/d/u/0/viewer?hl=en&mid=1826TEZz4mbjpCzArUnUTQtPc0x0&ll=-2.343556300000003%2C36.04584369999999&z=14",
        startDate: "12 Jan, 2021",
        endDate: "",
        description: "Lake Natron is a salt or alkaline lake located in north Ngorongoro District of Arusha Region in Tanzania. It is in the Gregory Rift, which is the eastern branch of the East African Rift. The lake is within the Lake Natron Basin, a Ramsar Site wetland of international significance.You will turn to stone",
        imageUrl: "https://cdn.mos.cms.futurecdn.net/DoPKTwv4W3pnANWJu5bVLb.jpg",
        badge:'dangerous'
    },{
        title: "Naica Crystal Cave",
        location: "Mexico",
        googleMapsUrl: "https://mapcarta.com/N4239277299",
        startDate: "12 Jan, 2009",
        endDate: "till date",
        description: "The Cave of Crystals, as it became named, is nestled 290 m underground, topped by a mountain rich in lead, zinc, and silver. This place is so humid that a visitor who lingered too long risked having fluids condense inside his or her lungs. That can be fatal. NASA discovered microbial life forms trapped inside one of the crystals that may have laid dormant for up to 50,000 years.",
        imageUrl: "https://3.bp.blogspot.com/-wdBz7VMs19c/V25mKZ2vmQI/AAAAAAAAI1o/5U7Ix05PxTknApzIBRur1i0F-5SJkk6pwCLcB/s1600/Cave%2Bof%2BCrystals%2B-Giant%2BCrystal%2BCave.jpg",
        badge :'dangerous'
    },
]